import useSWR from 'swr'
import { usersApi } from '@/lib/api'
import { useAuth } from '@/lib/config/auth-provider'
import { isTrialLike } from '@/lib/billing/tier'

export type ChatBlockReason = 'none' | 'locked_free' | 'trial_expired' | 'out_of_credits'

export function useChatBlockReason(): ChatBlockReason {
  const { isAuthenticated } = useAuth()
  // Gate SWR on auth state so the request never fires for unauthenticated
  // share/public-page visitors, where a 401 would otherwise hard-redirect.
  const { data: profile } = useSWR(
    isAuthenticated ? 'profile' : null,
    () => usersApi.getProfile(),
    {
      revalidateOnFocus: false,
      dedupingInterval: 30_000,
    },
  )
  if (!profile) return 'none'
  if (profile.subscriptionTier === 'locked_free') return 'locked_free'
  const balance = profile.creditInfo?.balance ?? 0
  if (isTrialLike(profile.subscriptionTier)) {
    if (balance <= 0) return 'trial_expired'
    if (profile.trialEndsAt && new Date(profile.trialEndsAt) < new Date()) return 'trial_expired'
  }
  if (balance <= 0 && !profile.creditInfo?.allowOverage) return 'out_of_credits'
  return 'none'
}
